import React, { useState } from "react";
import ReactCalendar from "react-calendar";
import CalendarIcon from "../../../assets/calendar.svg";
import moment from "moment";
function Calendar({ calenderDate, setcalenderDate, maxDate }) {
  const [showCalendar, setShowCalendar] = useState(false);
  const handleDispalyCalerdar = () => {
    setShowCalendar(!showCalendar);
  };
  const handleDate = (e) => {
    setcalenderDate(e);
    setShowCalendar(!showCalendar);
  };
  return (
    <div className="calendar-main-box-section">
      <div onClick={handleDispalyCalerdar} className="calendar-box-for-date">
        <div>
          {calenderDate ? (
            moment(calenderDate).format("DD/MM/YYYY")
          ) : (
            <span>DD/MM/YYYY</span>
          )}
        </div>
        <img src={CalendarIcon} alt="calender icon" />
      </div>
      {showCalendar && (
        <div
          id="react-calendar-overley"
          className={`${calenderDate && "date-already-selected"}`}
        >
          <ReactCalendar
            onChange={handleDate}
            value={calenderDate}
            minDate={new Date()}
            maxDate={
              maxDate ? maxDate : moment(new Date()).add(12, "months")._d
            }
            className="calendar-view"
          />
        </div>
      )}
    </div>
  );
}

export default Calendar;
